import React, { useContext, useState } from 'react';
import { Box, Typography, Chip, Avatar } from '@mui/material';
import { styled, keyframes } from '@mui/material/styles';
import { PerformerContext } from '../contexts/PerformerContext';
import CamEmbedModal from './CamEmbedModal';
import { PreRollAd } from './TwinredPreRoll';

const glow = keyframes`0%,100%{box-shadow:0 0 8px #FFD700}50%{box-shadow:0 0 20px #FFD700,0 0 40px #FFD70044}`;
const tick  = keyframes`0%{opacity:1}50%{opacity:0.3}100%{opacity:1}`;

const GoldCard = styled(Box)(({ theme }) => ({
  position: 'relative', borderRadius: 12, overflow: 'hidden', cursor: 'pointer',
  border: '2px solid #FFD700',
  animation: `${glow} 2.5s ease-in-out infinite`,
  flexShrink: 0,
  width: 160,
  [theme.breakpoints.up('sm')]: { width: 200 },
  '&:hover img': { transform: 'scale(1.05)' },
}));

const GoldShowsSection = () => {
  const { performers } = useContext(PerformerContext);
  const goldPerformers = performers.filter(p => p.goldShow).slice(0, 8);
  const [embedPerformer, setEmbedPerformer] = useState(null);
  const [preRollPending, setPreRollPending] = useState(null);

  if (goldPerformers.length === 0) return null;

  return (
    <>
      {preRollPending && (
        <PreRollAd onComplete={() => { setEmbedPerformer(preRollPending); setPreRollPending(null); }} />
      )}
      {embedPerformer && (
        <CamEmbedModal
          performer={embedPerformer}
          allPerformers={goldPerformers}
          onClose={() => setEmbedPerformer(null)}
        />
      )}

      <Box sx={{ width: '100%', maxWidth: 800, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
          <Typography sx={{ fontWeight: 800, fontSize: '1rem' }}>🥇 Gold Shows</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, bgcolor: '#fff8e1',
            border: '1px solid #FFD700', borderRadius: '12px', px: 1, py: 0.3 }}>
            <Box sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#FF4444',
              animation: `${tick} 1s ease-in-out infinite` }} />
            <Typography sx={{ fontSize: '0.7rem', fontWeight: 700, color: '#e65100' }}>LIVE NOW</Typography>
          </Box>
          <Typography variant="caption" sx={{ color: '#aaa' }}>
            {goldPerformers.length} shows active
          </Typography>
        </Box>

        {/* Horizontal scroll row */}
        <Box sx={{ display: 'flex', gap: 1.5, overflowX: 'auto', pb: 1,
          '&::-webkit-scrollbar': { height: 4 },
          '&::-webkit-scrollbar-thumb': { bgcolor: '#FFD700', borderRadius: 2 } }}>
          {goldPerformers.map(p => (
            <GoldCard key={p.uniqueModelId} onClick={() => setPreRollPending(p)}>
              <Box
                component="img"
                src={p.gallery?.[0]?.full || p.profilePictureFullUrl || p.profilePictureUrl}
                alt={`${p.displayName} gold show`}
                sx={{ width: '100%', height: 220, objectFit: 'cover',
                  transition: 'transform 0.3s ease', display: 'block' }}
                onError={e => { e.target.src = p.profilePictureUrl || ''; }}
              />
              <Box sx={{ position: 'absolute', top: 6, left: 6 }}>
                <Chip label="🥇 GOLD" size="small"
                  sx={{ bgcolor: '#FFD700', color: '#000', fontWeight: 800, fontSize: '0.65rem', height: 20 }} />
              </Box>
              <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0,
                background: 'linear-gradient(transparent, rgba(0,0,0,0.85))', p: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Avatar src={p.profilePictureUrl} sx={{ width: 20, height: 20 }} />
                  <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '0.75rem',
                    whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {p.displayName}
                  </Typography>
                </Box>
              </Box>
            </GoldCard>
          ))}
        </Box>
      </Box>
    </>
  );
};

export default GoldShowsSection;
